import { LifeBuoy } from 'lucide-react';
import { Button } from '@/shared/components';
import type { WorkspaceSummaryResponse } from '@/shared/api';
import { cn } from '@/shared/lib/cn';

export function WorkspaceRowActions({
  workspace,
  busy,
  onToggle,
  onSupport,
  supportPending,
  fullWidth = false,
}: {
  workspace: WorkspaceSummaryResponse;
  busy: boolean;
  onToggle: (workspace: WorkspaceSummaryResponse) => void;
  onSupport: (workspace: WorkspaceSummaryResponse) => void;
  supportPending: boolean;
  fullWidth?: boolean;
}) {
  if (workspace.kind === 'Platform') {
    return (
      <span className="text-ink-faint text-xs">
        Der Plattform-Workspace lässt sich nicht sperren
      </span>
    );
  }
  const width = fullWidth ? 'min-h-11 w-full' : 'min-h-11';
  return (
    <div className={cn('flex flex-col gap-2', fullWidth ? 'items-stretch' : 'items-end')}>
      {workspace.isActive && (
        <Button
          type="button"
          variant="primary"
          className={width}
          leftIcon={<LifeBuoy size={14} aria-hidden />}
          onClick={() => onSupport(workspace)}
          disabled={busy || supportPending}
        >
          Support-Sitzung
        </Button>
      )}
      <Button
        type="button"
        variant={workspace.isActive ? 'ghost' : 'brand'}
        className={width}
        loading={busy}
        disabled={supportPending}
        onClick={() => onToggle(workspace)}
      >
        {workspace.isActive ? 'Workspace sperren' : 'Workspace freigeben'}
      </Button>
    </div>
  );
}
